import { Link } from 'react-router-dom';
const SettingsTabs = (props) => {
    return (
            <ul className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3" role="tablist">
                <li className="nav-item" role="presentation">
                    <Link to={"/suppliers"} className={props.pageName === "SUPPLIER" ? "nav-link active bg-primary text-white" : "nav-link"}>SUPPLIERS</Link>
                </li>
                <li className="nav-item" role="presentation">
                    <Link to={"/paymentgateways"} className={props.pageName === "PAYMENTGATEWAY" ? "nav-link active bg-primary text-white" : "nav-link"}>PAYMENT GATEWAY</Link>
                </li>
                <li className="nav-item" role="presentation">
                    <Link to={"/credithistory"} className={props.pageName === "CREDITHISTORY" ? "nav-link active bg-primary text-white" : "nav-link"}>CREDIT HISTORY</Link>
                </li>
            </ul>
    );
};

export default SettingsTabs;
